import React, { useState } from 'react';
import { Clear } from '@mui/icons-material';

import { useUser } from 'contexts/UserContext';

import { INSIGHT } from 'utils/rest';

import { Text, Tooltip } from 'components/DataDisplay';
import { TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';
import { Paper } from 'components/Surfaces';

import { IconButton } from '../IconButton';

export const GeoInterfaceCustomization = ({
  params,
  setParams,
  color = null,
  bgColor = null,
  audienceType,
  geoInterface
}) => {
  const [value, setValue] = useState('');
  const [err, setErr] = useState(false);
  const { user } = useUser();
  const onValidateGeoCode = async code => {
    if (!geoInterface.size || geoInterface.size === code.length) {
      const results = await INSIGHT.getGeoZone({
        searchFields: [
          {
            searchField: code,
            type: audienceType
          }
        ],
        geo: false
      });
      if (!results || results.length === 0) {
        setErr(true);
      } else {
        setParams([...params, results[0]]);
        setValue('');
      }
    } else {
      setErr(true);
    }
  };

  const deleteGeoCode = geoCode => {
    setParams(params.filter(el => el.key !== geoCode));
  };

  const audienceTypeName = geoInterface.name[user.language];
  return (
    <Container>
      <Row justify="flex-start" alignItems="center" spacing={0}>
        <Item xs={6}>
          <TextField
            small
            title={geoInterface.name[user.language]}
            error={err}
            bgColor={bgColor}
            placeholder={`Saisissez un ${audienceTypeName} + entrée`}
            errorText={`${audienceTypeName} incorrect ou déjà ajouté`}
            value={value}
            clearable
            color={color}
            onChange={e => {
              setValue(e);
              setErr(false);
            }}
            onEnter={e => {
              onValidateGeoCode(e);
            }}
          />
        </Item>
      </Row>
      <Row spacing={3}>
        {params.length !== 0 &&
          params?.map(element => {
            return (
              <Item
                xs
                key={element.key}
                style={{
                  flexBasis: 'auto',
                  flexGrow: 0
                }}
              >
                <Paper
                  style={{
                    width: '100%',
                    minWidth: '100%'
                  }}
                >
                  <Row spacing={1}>
                    <Item xs={4}>
                      <Text bold>{element.key}</Text>
                    </Item>
                    <Item xs={6}>
                      {element?.name?.split(', ').length !== 1 ? (
                        <Tooltip title={element.name}>
                          <Text noWrap style={{ 'max-width': '250px' }}>
                            {element.name}
                          </Text>
                        </Tooltip>
                      ) : (
                        <Text noWrap style={{ 'max-width': '250px' }}>
                          {element.name}
                        </Text>
                      )}
                    </Item>
                    <Item xs={2}>
                      <IconButton>
                        <Clear
                          fontSize="small"
                          onClick={() => deleteGeoCode(element.key)}
                        />
                      </IconButton>
                    </Item>
                  </Row>
                </Paper>
              </Item>
            );
          })}
      </Row>
    </Container>
  );
};

export default GeoInterfaceCustomization;
